import React from "react"
import type { ReducedBlogV2ArticleType } from "types/blog-v2-types"

import { blogSlug } from "components/Blog/utils/Blog.utils"

import {
  container,
  headerContainer,
  postsContainer,
  viewAll,
} from "./PostRelatedContent.css"
import { BlogArticleCardV2 } from "../../Shared/BlogArticleCard"

type Props = {
  relatedContent: ReducedBlogV2ArticleType[]
  locale: "en-GB" | "en-US"
}

export const PostRelatedContent: React.FC<Props> = ({
  relatedContent,
  locale,
}) => {
  const blogSlugToUse = locale === "en-US" ? `/us${blogSlug}` : blogSlug
  return (
    <div className={container}>
      <div className={headerContainer}>
        <h4>Related Content</h4>
      </div>
      <div className={postsContainer}>
        {relatedContent.map((post) => (
          <BlogArticleCardV2 key={post.slug} article={post} desktopCols={3} />
        ))}
      </div>
      <div className={viewAll}>
        <a href={blogSlugToUse} title="Load more blog posts">
          View All
        </a>
      </div>
    </div>
  )
}
